import { Box, Card, Typography, Stack, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

// Single CustomCard component accepting label, value, bgColor, and iconURL as props
export default function CustomCard({ value, label, bgColor, iconURL, loading, ...rest }) {
    return (
        <Card
            sx={{
                display: 'flex',
                alignItems: 'center',
                height: "150px",
                p: 4,
                cursor: 'pointer', // Makes the cursor a pointer when hovered
                transition: 'box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out', // Smooth transition for visual effects
                '&:hover': {
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)', // Shadow effect on hover
                },
            }}
            {...rest}
        >
            <Stack direction="row" alignItems="center" spacing={2}>

                {/* Display Value and Label */}
                <Stack direction="column" spacing={0.5}>
                    {/* <Box sx={{ fontSize: "2rem", fontWeight: 'bold', fontFamily: "Barlow" }}>{value}</Box> */}

                    {loading ? (
                        <CircularProgress color="inherit" />
                    ) : (
                        <Box sx={{ fontSize: "2rem", fontWeight: 'bold', fontFamily: "Barlow" }}>{value}</Box>

                    )}


                    <Typography
                        variant="subtitle2"
                        sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: "#637381" }}
                    >
                        {label}
                    </Typography>
                </Stack>
            </Stack>

            <Box
                component="img"
                src={iconURL}
                alt="icon"
                sx={{
                    width: 40,
                    height: 40,
                    objectFit: 'contain', // Ensure the icon maintains aspect ratio
                    position: "absolute",
                    top: "38px",
                    right: "25px"
                }}
            />
            {/* Optional decorative element */}
            <Box
                sx={{
                    position: 'absolute',
                    // top: '-20px',
                    // right: '-94px',
                    top: "-30px",
                    right: "-86px",
                    width: 160,
                    height: 160,
                    zIndex: -1,
                    opacity: 0.12,
                    borderRadius: '24px',
                    transform: 'rotate(40deg)',
                    background: bgColor, // Dynamic background color
                }}
            />
        </Card >
    );
};

CustomCard.propTypes = {
    value: PropTypes.number,
    label: PropTypes.object,
    bgColor: PropTypes.string,
    iconURL: PropTypes.string,
    loading: PropTypes.any,
    rest: PropTypes.any,
};



